import { useQuery } from "react-query";
import { fetchBestWorstSegmentData } from "./api";

export function useBestWorstSegment(filters, options={}) {
    return useQuery(["BestWorstSegmentData", filters], () => fetchBestWorstSegmentData(filters), {
      staleTime: 60000 * 60, 
      ...options
    })
  }